export const FEATURED_JOBS = [
  {
    id: 1,
    title: "Landscaping Crew Member",
    company: "GreenScape Pro",
    companyAbout: "GreenScape Pro has been transforming residential and commercial outdoor spaces across the metro area since 2011. With a crew of 60+ professionals and over 4,000 five-star reviews, we're the region's most trusted landscaping company.",
    pay: "$22/hr",
    payNum: 22,
    distance: "1.2 mi",
    distanceNum: 1.2,
    urgency: "TODAY",
    urgencyColor: "red",
    category: "Landscaping",
    icon: "ri-plant-line",
    location: "4820 Willow Creek Blvd, Austin, TX 78745",
    schedule: "7:00 AM – 3:00 PM",
    startDate: "Today",
    capabilities: ["Outdoor Work", "Physical Labor", "Tools"],
    match: 96,
    description: "Join our landscaping crew for same-day work. Mowing, trimming, and general yard maintenance.",
    fullDescription:
      "We need reliable crew members today for scheduled residential lawn maintenance across 8 properties in the South Austin corridor. Work includes precision mowing with commercial walk-behinds, edging sidewalks and driveways, trimming around obstacles, blowing clippings, and bagging debris where required. Our team lead will brief you on-site. All heavy equipment is provided — just bring your work boots and a can-do attitude.",
    requirements: [
      "Able to work outdoors in heat for 8-hour shifts",
      "Physically capable of operating push mowers and string trimmers",
      "Steel-toed boots required",
      "Must arrive on time — crew departs at 7:00 AM sharp",
      "No experience required — we train on the spot",
    ],
    perks: ["Paid same day via direct deposit", "Lunch break provided", "Potential for recurring weekend work"],
    posted: "2 hours ago",
    slots: 3,
  },
  {
    id: 2,
    title: "Moving Assistant",
    company: "QuickMove Solutions",
    companyAbout: "QuickMove Solutions is Austin's highest-rated on-demand moving company. We complete 200+ moves per month with a 4.8-star average across 3,000+ reviews. We pride ourselves on careful, fast, professional service every time.",
    pay: "$28/hr",
    payNum: 28,
    distance: "0.8 mi",
    distanceNum: 0.8,
    urgency: "URGENT",
    urgencyColor: "red",
    category: "Moving / Labor",
    icon: "ri-truck-line",
    location: "212 Barton Springs Rd, Austin, TX 78704",
    schedule: "10:00 AM – 6:00 PM",
    startDate: "Today",
    capabilities: ["Heavy Lifting", "Physical Labor", "Truck Access"],
    match: 91,
    description: "Help with residential move. Loading/unloading furniture. Must be able to lift 50+ lbs.",
    fullDescription:
      "A family in Barton Hills needs two additional crew members for their full home move today. The job involves wrapping and protecting furniture, carefully loading a 26-ft truck, driving convoy to the new address (2.3 miles), and unloading into the correct rooms per the client's instructions. This is a premium-tier client — professionalism and care for belongings is paramount. Overtime is possible and paid at 1.5x.",
    requirements: [
      "Must be able to lift and carry 50+ lbs repeatedly",
      "Valid government ID required",
      "Prior moving experience preferred but not required",
      "Ability to follow verbal instructions quickly",
      "Clean, presentable appearance — client-facing role",
    ],
    perks: ["Overtime available at 1.5x rate", "Tips from clients (average $40–80/job)", "Paid within 2 hours of completion"],
    posted: "45 min ago",
    slots: 2,
  },
  {
    id: 3,
    title: "Office Cleaning Specialist",
    company: "SparkClean Corp",
    companyAbout: "SparkClean Corp provides commercial cleaning services to 300+ businesses in the Austin metro area. We operate 24/7, serving everything from boutique offices to large corporate campuses. Our team is trained, uniformed, and insured.",
    pay: "$18/hr",
    payNum: 18,
    distance: "2.4 mi",
    distanceNum: 2.4,
    urgency: "THIS WEEK",
    urgencyColor: "orange",
    category: "Cleaning",
    icon: "ri-service-line",
    location: "900 Congress Ave, Austin, TX 78701",
    schedule: "6:00 PM – 10:00 PM",
    startDate: "Wednesday",
    capabilities: ["Cleaning", "Organizing", "Basic Tools"],
    match: 88,
    description: "Evening cleaning shift at a downtown office building. Supplies provided.",
    fullDescription:
      "We need a thorough, detail-oriented cleaner for a downtown high-rise office spanning three floors (8,400 sq ft). Duties include vacuuming all open-plan spaces, sanitizing restrooms and kitchenettes, emptying bins, wiping glass and surfaces, and restocking consumables from our on-site supply closet. All cleaning products and equipment are provided. This is an excellent opportunity for a recurring weekly schedule if you perform well.",
    requirements: [
      "Previous cleaning or janitorial experience preferred",
      "Attention to detail and thoroughness required",
      "Must be comfortable working independently with minimal supervision",
      "Background check required (processed in under 24 hours)",
      "Ability to stand and move for 4-hour shifts",
    ],
    perks: ["Supplies and uniform provided", "Opportunity for recurring weekly shifts", "Friendly and flexible management"],
    posted: "3 hours ago",
    slots: 5,
  },
  {
    id: 4,
    title: "Event Setup Crew",
    company: "Premier Events Co.",
    companyAbout: "Premier Events Co. has produced 1,500+ corporate and private events across Texas since 2008. From intimate boardroom meetings to 2,000-person galas, our production team delivers flawlessly every time.",
    pay: "$20/hr",
    payNum: 20,
    distance: "3.1 mi",
    distanceNum: 3.1,
    urgency: "TOMORROW",
    urgencyColor: "orange",
    category: "Events",
    icon: "ri-calendar-event-line",
    location: "500 E Cesar Chavez St, Austin, TX 78701",
    schedule: "6:00 AM – 2:00 PM",
    startDate: "Tomorrow",
    capabilities: ["Physical Labor", "Organizing", "Teamwork"],
    match: 84,
    description: "Setup and breakdown for corporate event. Tables, chairs, AV equipment placement.",
    fullDescription:
      "We're producing a 400-person tech summit at the Austin Convention Center and need experienced event crew for setup. The role involves unboxing and placing 50 round tables, positioning 400 chairs, running cable raceways for AV, placing signage, and dressing the main stage. A detailed floor plan will be provided. Breakdown crew is also needed after the event ends (~6 PM) with separate shifts available.",
    requirements: [
      "Ability to lift up to 40 lbs and move quickly on your feet",
      "Must be able to interpret simple floor plan diagrams",
      "Punctuality is non-negotiable — early call time of 6:00 AM",
      "Professional behavior around client stakeholders",
      "Experience in events, hospitality, or production a plus",
    ],
    perks: ["Catered crew meals on-site", "Repeat shifts available for full event season", "Bonus for breakdown crew staying late"],
    posted: "1 hour ago",
    slots: 8,
  },
  {
    id: 5,
    title: "Construction Laborer",
    company: "BuildRight LLC",
    companyAbout: "BuildRight LLC is a full-service general contractor with 18 years of experience across residential and commercial projects in Central Texas. We hold a Class A contractor license and maintain an impeccable safety record.",
    pay: "$32/hr",
    payNum: 32,
    distance: "4.5 mi",
    distanceNum: 4.5,
    urgency: "THIS WEEK",
    urgencyColor: "orange",
    category: "Construction",
    icon: "ri-building-2-line",
    location: "7200 N Lamar Blvd, Austin, TX 78752",
    schedule: "7:00 AM – 4:00 PM",
    startDate: "Thursday",
    capabilities: ["Heavy Lifting", "Outdoor Work", "Tools", "Car Access"],
    match: 79,
    description: "General labor on residential construction site. Material handling and site cleanup.",
    fullDescription:
      "We need reliable laborers for a fast-moving residential new-build project in North Austin. Primary duties include offloading lumber and drywall deliveries, moving materials between floors using manual equipment, maintaining site cleanliness per OSHA standards, and assisting trade subcontractors as directed by the site super. Hard hat and high-visibility vest provided. This project runs through Q2 with steady work available for top performers.",
    requirements: [
      "OSHA 10 certification preferred (we will reimburse cost)",
      "Steel-toed boots and gloves required",
      "Reliable transportation to job site — no public transit access",
      "Comfortable with physically demanding outdoor work in all weather",
      "Must pass a basic site safety orientation on first day",
    ],
    perks: ["Highest hourly rate in category", "Long-term project with guaranteed weeks", "OSHA certification reimbursed"],
    posted: "5 hours ago",
    slots: 4,
  },
  {
    id: 6,
    title: "Personal Driver (Gig)",
    company: "FlexDrive Network",
    companyAbout: "FlexDrive Network is a premium personal driving platform connecting vetted, professional drivers with clients who need reliable, discreet transportation for daily errands, airport runs, and personal appointments.",
    pay: "$25/hr",
    payNum: 25,
    distance: "Remote",
    distanceNum: 0,
    urgency: "FLEXIBLE",
    urgencyColor: "green",
    category: "Personal Services",
    icon: "ri-car-line",
    location: "Greater Austin Metro Area",
    schedule: "Flexible — set your own hours",
    startDate: "Anytime",
    capabilities: ["Car Access", "Driving", "Customer Service"],
    match: 93,
    description: "Flexible driving gigs. Grocery runs, airport pickups, personal errands. Set your own hours.",
    fullDescription:
      "FlexDrive is expanding its driver network in Austin and we're looking for professional, courteous drivers to serve our premium client base. Tasks include airport pickups and drop-offs, grocery and pharmacy runs, dry-cleaning pickups, and escorting clients to medical appointments. You work when you want — our app lets you toggle availability in real time. Clients rate you after each job, and top-rated drivers unlock premium, higher-paying assignments.",
    requirements: [
      "Valid Texas driver's license with clean 3-year record",
      "Own a 2018 or newer vehicle (sedan, SUV, or minivan)",
      "Smartphone with data plan for app usage",
      "Excellent interpersonal skills and professional demeanor",
      "Ability to pass background and DMV check",
    ],
    perks: ["100% flexible schedule — work when you want", "Tips on top of hourly rate (avg $12–25/trip)", "Premium client tier unlocked after 10 five-star reviews"],
    posted: "30 min ago",
    slots: 10,
  },
];

export const URGENCY_JOBS_COUNT = 847;
export const ACTIVE_WORKERS = 12400;
export const AVG_MATCH_TIME = "4 min";
export const CITIES_COVERED = 230;

export const INCOME_STATS = {
  totalEarned: "$4,280",
  thisWeek: "$620",
  activeJobs: 2,
  pendingOffers: 5,
  rating: 4.9,
  completedJobs: 47,
};

export const RECENT_JOBS = [
  { id: 1, title: "Landscaping — Green Valley Homes", date: "Mar 28", hours: 6, earned: "$132", status: "Completed" },
  { id: 2, title: "Moving Crew — Rodriguez Family", date: "Mar 25", hours: 8, earned: "$224", status: "Completed" },
  { id: 3, title: "Event Setup — Tech Summit 2026", date: "Mar 22", hours: 4, earned: "$80", status: "Completed" },
  { id: 4, title: "Office Cleaning — Apex Tower", date: "Mar 19", hours: 5, earned: "$90", status: "Completed" },
];

export const UPSKILL_SUGGESTIONS = [
  {
    title: "OSHA 10-Hour Construction Safety",
    currentPay: "$22/hr",
    newPay: "$38/hr",
    timeToComplete: "2 days",
    icon: "ri-shield-check-line",
    color: "blue",
  },
  {
    title: "Forklift Operator Certification",
    currentPay: "$18/hr",
    newPay: "$29/hr",
    timeToComplete: "1 day",
    icon: "ri-loader-4-line",
    color: "green",
  },
  {
    title: "CDL Class B License",
    currentPay: "$25/hr",
    newPay: "$52/hr",
    timeToComplete: "3 weeks",
    icon: "ri-truck-line",
    color: "orange",
  },
];
